import dayjs from 'dayjs';

export const sendTracker = (
  event = 'event',
  eventCategory,
  eventAction,
  eventLabel,
  eventValue = dayjs().unix(),
  leadId = null,
  skipFacebook = false
) => {
  const { dataLayer, fbq } = window;

  dataLayer.push({
    event,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    userId: leadId
  });

  if (!skipFacebook && fbq) {
    fbq('track', 'Lead', {
      content_category: eventAction,
      contents: eventLabel
    });
  }
};

export const GTM = {
  sendGAEvent: (lead, eventAction) => {
    sendTracker('event', 'lead-dedup-submit', eventAction, lead.category, dayjs().unix(), lead.id);
    const isNewLead = lead.new_lead;
    if (isNewLead) {
      sendTracker(
        'event',
        'lead-submit',
        eventAction,
        lead.category,
        dayjs().unix(),
        lead.id,
        true
      );
    }
  },

  sendClaimGAEvent: (data, eventAction) => {
    sendTracker('event', 'user-submit', eventAction, data.category);
  }
};
